export function suggestEventPage()
{
    var myDropzone = null;

    function suggest_form()
    {
        var date            = new Date();
        var format_date     = moment(date).format('Y-MM-DD hh:mm:ss A');

        $('input[name="eventStartDate"]').daterangepicker({
            timePicker: true,
            minYear: date.getFullYear(),
            minDate: format_date,
            startDate: moment().startOf('hour'),
            endDate: moment().startOf('hour').add(32, 'hour'),
            locale: revent_data.pll_suggest_date,
        });

        jQuery(document).ready(function() {
            $('.success-response-message-wrp').removeClass('show');
            var $form = $('form.suggest-form');

            $('span.eventAllDay').on('click', function(){
                if($(this).find('[name="eventAllDay[]"]').is(':checked')) {
                    $(this).find('[name="eventAllDay[]"]').prop("checked", false);
                    $('input[name="eventStartDate"]').daterangepicker({
                        timePicker: true,
                        minYear: date.getFullYear(),
                        minDate: format_date,
                        startDate: moment().startOf('hour'),
                        endDate: moment().startOf('hour').add(32, 'hour'),
                        locale: revent_data.pll_suggest_date,
                    });

                } else {
                    $(this).find('[name="eventAllDay[]"]').prop("checked", true);

                    $('input[name="eventStartDate"]').daterangepicker({
                        timePicker: false,
                        minYear: date.getFullYear(),
                        minDate: format_date,
                        startDate: moment().startOf('hour'),
                        endDate: moment().startOf('hour').add(32, 'hour'),
                        locale: revent_data.pll_suggest_date,
                    });
                }
            });

            $('span.withoutAddress').on('click', function () {
                if($(this).find('[name="withoutAddress[]"]').is(':checked')) {
                    $(this).find('[name="withoutAddress[]"]').prop("checked", false);
                    $form.find('div.event-venue-name, div.event-address, div.event-city').show();
                } else {
                    $(this).find('[name="withoutAddress[]"]').prop("checked", true);
                    $form.find('div.event-venue-name, div.event-address, div.event-city').hide();
                    $form.find('div.event-venue-name input, div.event-address input, div.event-city input').val('');
                }
            });

            myDropzone = new Dropzone("span.eventImage", {
                url: dropParam.upload,
                acceptedFiles: 'image/*',
                maxFiles: 1,
                thumbnailWidth: 500,
                thumbnailHeight: 500,
                addRemoveLinks: true,
                success: function (file, response) {
                    $form.find('[name="eventThumbnailID"]').val(response);
                    $("span.eventImage").addClass('removeEventListener');
                },
                error: function (file, response) {},
                removedfile: function(file) {
                    var attachment_id = $form.find('[name="eventThumbnailID"]').val();
                    jQuery.ajax({
                        type: 'POST',
                        url: dropParam.delete,
                        data: {
                            media_id : attachment_id
                        }
                    });
                    var _ref;
                    return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
                }
            });

            jQuery('#suggestEvent').submit(ajaxSubmit);
        });
    }

    function validate_suggest_form(error_data)
    {
        var $form = $('form.suggest-form');

        $form.find('.wpcf7-not-valid').removeClass('wpcf7-not-valid');
        $form.find('.wpcf7-not-valid-tip').remove();

        Object.keys(error_data).map(function (it) {
            $form.find('[name="'+it+'"]').addClass('wpcf7-not-valid').after('<span role="alert" class="wpcf7-not-valid-tip">'+error_data[it]+'</span>');
        });
    }

    function ajaxSubmit()
    {
        var $form           = $('form.suggest-form');
        var suggestEvent    = jQuery(this).serialize();

        $.ajax({
            type: 'POST',
            url: revent_data.ajax_url,
            data: {
                action: 'suggest_event',
                data: suggestEvent
            },
            success: function(data){
                if(data.error){
                    validate_suggest_form(data.error);
                } else {
                    $('.success-response-message-wrp').addClass('show');
                    $('body').addClass('scroll_disabled');
                    $form.find("input[type=text], input[type=email], input[type=url], textarea").val("");
                    tinyMCE.get('my_option').setContent('');
                    $form.find('.dz-image-preview').remove();
                    $form.find('.wpcf7-not-valid').removeClass('wpcf7-not-valid');
                    $form.find('.wpcf7-not-valid-tip').remove();


                }
            }
        });

        return false;
    }


    if($('form.suggest-form').length > 0){

        $('.success-response-message-wrp i').on('click', function () {
            $('body').removeClass('scroll_disabled');
            $('.success-response-message-wrp').removeClass('show');
        });


        suggest_form();
    }

}


// WEBPACK FOOTER //
// ./assets/js/pages/suggest_an_events.js